export default {
    globalSnackbar: state => state.globalSnackbar,
}